import { useNavigate } from 'react-router-dom';
import { signOut } from "../../api/users/signOut";
import { setCookie } from '../../utils';

import "./index.css";

function SignedInDropdown() {
  const navigate = useNavigate();

  const opts = [
    {
      name: "Logout",
      icon: (
        <>
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="18" fill="#EDEDED"/>
            <path d="M19.0012 27C19.0012 27.553 18.5532 28 18.0012 28H14.0012C11.2442 28 9.00122 25.757 9.00122 23V13C9.00122 10.243 11.2442 8 14.0012 8H18.0012C18.5532 8 19.0012 8.447 19.0012 9C19.0012 9.553 18.5532 10 18.0012 10H14.0012C12.3472 10 11.0012 11.346 11.0012 13V23C11.0012 24.654 12.3472 26 14.0012 26H18.0012C18.5532 26 19.0012 26.447 19.0012 27ZM26.9232 18.382C27.0242 18.138 27.0242 17.862 26.9232 17.618C26.8722 17.495 26.7992 17.385 26.7062 17.292L22.7072 13.293C22.3162 12.902 21.6842 12.902 21.2932 13.293C20.9022 13.684 20.9022 14.316 21.2932 14.707L23.5862 17H16.0002C15.4482 17 15.0002 17.447 15.0002 18C15.0002 18.553 15.4482 19 16.0002 19H23.5862L21.2932 21.293C20.9022 21.684 20.9022 22.316 21.2932 22.707C21.4882 22.902 21.7442 23 22.0002 23C22.2562 23 22.5122 22.902 22.7072 22.707L26.7062 18.708C26.7992 18.615 26.8732 18.505 26.9232 18.382Z" fill="#131313"/>
          </svg>
        </>
      )
    },
  ];

  async function logout() {
    try {
      await signOut();
      navigate("/");
      setCookie("jwtToken", "");
      localStorage.setItem('teacher', null);
      localStorage.setItem('studentEnrolledLibraryId', null);
    } catch (error) {
      console.log(error)
    }
  }

  async function onClick(name, url) {
    if (name === "Logout") {
      await logout();
      return;
    }

    navigate("/student_library")
  }

  return (
    <div className="TractusNavbarDropdown">
      {opts.map(({ name, url, icon }, key) => {
        return (
          <div
            key={key}
            className="TractusNavbarDropdownOption"
            onClick={() => onClick(name, url)}
          >
            {icon}
            {name}
          </div>
        )
      })}
    </div>
  )
}

export { SignedInDropdown }
